import { render, staticRenderFns } from "./ParceirosRedeNeutra.vue?vue&type=template&id=cb81b3ac&"
import script from "./ParceirosRedeNeutra.vue?vue&type=script&lang=js&"
export * from "./ParceirosRedeNeutra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports